// Date pure (constante) extrase din App.js — fără dependențe de React sau de logica aplicației.

export const MONTHS = ["Ianuarie","Februarie","Martie","Aprilie","Mai","Iunie","Iulie","August","Septembrie","Octombrie","Noiembrie","Decembrie"];

export const MSHORT = ["Ian","Feb","Mar","Apr","Mai","Iun","Iul","Aug","Sep","Oct","Nov","Dec"];

export const DOSE_FORMS = ["Comprimată","Comprimată filmat","Comprimată efervescentă","Comprimată sublinguală","Capsulă","Capsulă cu eliberare prelungită","Fiolă","Perfuzie","Soluție injectabilă","Picături orale","Picături oftalmice","Picături auriculare","Spray nazal","Spray bucal","Spray cutanat","Plasture","Supozitor","Sirop","Suspensie orală","Granule","Pulbere","Cremă","Unguent","Gel","Spumă","Ovul","Inhaler","Nebulizator","Alta"];

export const SPECS = ["Alergologie","Anestezie terapie durere","Boli infecțioase","Cardiologie","Chirurgie cardiovasculară","Chirurgie generală","Chirurgie orală și maxilo-facială","Chirurgie pediatrică","Chirurgie plastică","Chirurgie toracică","Chirurgie vasculară","Dermatologie","Diabet zaharat și boli de nutriție","Endocrinologie","Gastroenterologie","Genetică medicală","Geriatrie","Ginecologie","Hematologie","Imunologie clinică","Medicină de familie","Medicină generală","Medicină internă","Medicină sportivă","Nefrologie","Neonatologie","Neurochirurgie","Neurologie","Nutriție și dietetică","Obstetrică-ginecologie","Oftalmologie","Oncologie","Ortodonție","Ortopedie","ORL","Paliație","Pediatrie","Pneumologie","Psihiatrie","Psihologie","Radioterapie","Recuperare medicală","Reumatologie","Stomatologie","Urologie","Alta"];

export const SYMPTOMS_LIST = [
  "Aciditate gastrică","Amețeală","Amorțeală în membre","Apnee de somn","Balonare",
  "Cârcei musculari","Cojirea pielii","Constipație","Coșmaruri frecvente","Crampe stomacale",
  "Depresie","Dezorientare spațială","Diaree","Dificultate în respirație","Dificultate la înghițire",
  "Dificultate la mers","Dificultăți de concentrare","Durere abdominală","Durere de cap","Durere de ureche",
  "Durere în gât","Durere în piept","Durere lombară","Dureri articulare","Dureri de ochi","Dureri de spate",
  "Dureri musculare","Erupție cutanată","Febră","Foame excesivă","Frisoane","Furnicături în mâini sau picioare",
  "Ganglioni limfatici umflați","Greață","Gură uscată","Gust amarnic sau metalic","Incontinență urinară",
  "Insomnie","Iritabilitate crescută","Îngălbenirea ochilor","Îngălbenirea pielii","Lăcrimare excesivă",
  "Lipsă de coordonare","Luare bruscă în greutate","Mâncărime de piele","Nas înfundat","Oboseală accentuată",
  "Ochi uscați","Paloare accentuată","Palpitații","Pierderea echilibrului","Pierderea gustului",
  "Pierderea mirosului","Pierderea poftei de mâncare","Pierderea vocii","Piele uscată",
  "Plâns facil sau labilitate emoțională","Puls accelerat","Puls foarte scăzut","Regurgitare",
  "Respirație rapidă","Respirație șuierătoare","Rigiditate articulară","Răgușeală","Roșeață localizată",
  "Sângerare nazală","Scăderea auzului","Scădere bruscă în greutate","Senzație de căldură excesivă",
  "Senzație de frig permanent","Senzație de sufocare","Sensibilitate la lumină","Sensibilitate la zgomot",
  "Sete excesivă","Slăbiciune musculară","Somnolență excesivă","Spasme musculare","Stare de anxietate",
  "Stare de apatie","Stare de confuzie","Strănut frecvent","Scurgeri nazale","Transpirații abundente",
  "Transpirații nocturne","Tremurături ale mâinilor","Tulburări de memorie","Tuse cu sânge","Tuse productivă",
  "Tuse seacă","Țiuit în urechi","Umflarea feței","Umflarea mâinilor","Umflarea picioarelor",
  "Urinare dureroasă","Urinări frecvente","Urină cu sânge","Urină tulbure sau urât mirositoare",
  "Vânătăi apărute spontan","Vărsături","Vedere dublă","Vedere încețoșată","Vertij",
  "Migrenă","Reflux","Hemoroizi","Sughiț persistent",
  "Leșin","Stare de leșin","Durere de dinți","Sângerare gingii","Afte bucale","Respirație urât mirositoare",
  "Sânge în scaun","Scaune negre","Mucus în scaun","Deshidratare","Bufeuri",
  "Căderea părului","Unghii fragile","Modificări ale alunițelor","Vindecare lentă a rănilor",
  "Sforăit","Sforăit excesiv","Durere la înghițire","Senzație de nod în gât","Greutate în piept",
  "Bătăi neregulate ale inimii","Mâini și picioare reci","Crampe menstruale","Sângerare menstruală abundentă",
  "Scurgeri vaginale","Mâncărime genitală","Scădere a libidoului","Durere pelvină",
  "Tremor al întregului corp","Convulsii","Spasme faciale","Ticuri","Dificultate la vorbire",
  "Bâlbâială","Halucinații","Stare de agitație","Atacuri de panică","Gânduri negative",
  "Lipsă de energie","Stare de rău general","Frison cu febră","Transpirații reci",
  "Mâncărime generalizată","Urticarie","Umflarea limbii","Umflarea buzelor","Dificultate la urinare",
  "Senzație de golire incompletă a vezicii","Nicturie","Edem la nivelul abdomenului",
  "Durere de sâni","Sensibilitate la nivelul sânilor","Umflarea sânilor","Noduli la sâni",
  "Scurgeri mamelonare","Menstruație întârziată","Menstruație neregulată","Absența menstruației",
  "Sângerare între menstruații","Sângerare după menopauză","Menstruație dureroasă",
  "Sindrom premenstrual","Bufeuri (menopauză)","Uscăciune vaginală","Durere în timpul actului sexual",
  "Senzație de arsură vaginală","Miros vaginal neplăcut","Balonare premenstruală",
  "Schimbări de dispoziție premenstruale","Pofte alimentare premenstruale","Retenție de apă",
  "Altul"
];

export const KINSHIP = ["Soț","Soție","Fiu","Fiică","Mamă","Tată","Bunic","Bunică","Frate","Soră","Unchi","Mătușă","Nepot","Nepoată","Văr","Vară","Altul"];

export const PALETTE = ["var(--blue)","#f97316","var(--green)","var(--amber)","var(--purple)","var(--red)","#38bdf8","#4ade80","#fb7185","#e879f9"];

export const ALL_ANALYTES = [
  // Hematologie
  {name:"Hemoglobină",unit:"g/dL",min:12,max:17.5,cat:"Hematologie"},
  {name:"Hematocrit",unit:"%",min:36,max:52,cat:"Hematologie"},
  {name:"Leucocite",unit:"10³/μL",min:4,max:10,cat:"Hematologie"},
  {name:"Trombocite",unit:"10³/μL",min:150,max:400,cat:"Hematologie"},
  {name:"Eritrocite",unit:"10⁶/μL",min:3.8,max:5.8,cat:"Hematologie"},
  {name:"VSH",unit:"mm/h",min:0,max:20,cat:"Hematologie"},
  {name:"Neutrofile",unit:"%",min:50,max:75,cat:"Hematologie"},
  {name:"Limfocite",unit:"%",min:20,max:45,cat:"Hematologie"},
  {name:"Monocite",unit:"%",min:2,max:10,cat:"Hematologie"},
  {name:"Eozinofile",unit:"%",min:0,max:5,cat:"Hematologie"},
  {name:"Reticulocite",unit:"%",min:0.5,max:2.5,cat:"Hematologie"},
  {name:"Volum eritrocitar mediu (MCV)",unit:"fL",min:80,max:100,cat:"Hematologie"},
  {name:"Hemoglobină eritrocitară medie (MCH)",unit:"pg",min:27,max:33,cat:"Hematologie"},
  {name:"Concentrație medie de hemoglobină eritrocitară (MCHC)",unit:"g/dL",min:32,max:36,cat:"Hematologie"},
  // Biochimie
  {name:"Glicemie",unit:"mmol/L",min:3.9,max:6.1,cat:"Biochimie"},
  {name:"Creatinină",unit:"μmol/L",min:44,max:106,cat:"Biochimie"},
  {name:"Uree",unit:"mmol/L",min:2.5,max:7.1,cat:"Biochimie"},
  {name:"Azot ureic sanguin (BUN)",unit:"mg/dL",min:7,max:20,cat:"Biochimie"},
  {name:"Acid uric",unit:"μmol/L",min:155,max:428,cat:"Biochimie"},
  {name:"Bilirubină totală",unit:"μmol/L",min:3.4,max:20.5,cat:"Biochimie"},
  {name:"Proteine totale",unit:"g/L",min:66,max:83,cat:"Biochimie"},
  {name:"Albumină",unit:"g/L",min:35,max:52,cat:"Biochimie"},
  {name:"Fibrinogen",unit:"g/L",min:2,max:4,cat:"Biochimie"},
  {name:"Feritină",unit:"ng/mL",min:12,max:300,cat:"Biochimie"},
  {name:"Proteină C reactivă (PCR)",unit:"mg/L",min:0,max:5,cat:"Biochimie"},
  {name:"Procalcitonină",unit:"ng/mL",min:0,max:0.5,cat:"Biochimie"},
  // Enzime
  {name:"Alanin-aminotransferază (ALT)",unit:"U/L",min:7,max:56,cat:"Enzime"},
  {name:"Aspartat-aminotransferază (AST)",unit:"U/L",min:10,max:40,cat:"Enzime"},
  {name:"Gama-glutamiltransferază (GGT)",unit:"U/L",min:8,max:61,cat:"Enzime"},
  {name:"Fosfatază alcalină",unit:"U/L",min:44,max:147,cat:"Enzime"},
  {name:"Amilază",unit:"U/L",min:28,max:100,cat:"Enzime"},
  {name:"Lipază",unit:"U/L",min:0,max:60,cat:"Enzime"},
  {name:"Lactat dehidrogenază (LDH)",unit:"U/L",min:140,max:280,cat:"Enzime"},
  {name:"Creatin-kinază (CK)",unit:"U/L",min:30,max:200,cat:"Enzime"},
  {name:"Troponină",unit:"ng/mL",min:0,max:0.04,cat:"Enzime"},
  // Lipide
  {name:"Colesterol total",unit:"mmol/L",min:0,max:5.2,cat:"Lipide"},
  {name:"Colesterol LDL",unit:"mmol/L",min:0,max:3.4,cat:"Lipide"},
  {name:"Colesterol HDL",unit:"mmol/L",min:1.0,max:99,cat:"Lipide"},
  {name:"Trigliceride",unit:"mmol/L",min:0,max:1.7,cat:"Lipide"},
  // Hormoni
  {name:"Hormon de stimulare tiroidiană (TSH)",unit:"mUI/L",min:0.4,max:4.0,cat:"Hormoni"},
  {name:"Tiroxină liberă (FT4)",unit:"pmol/L",min:9,max:23,cat:"Hormoni"},
  {name:"Triiodotironină liberă (FT3)",unit:"pmol/L",min:3.5,max:6.5,cat:"Hormoni"},
  {name:"Hemoglobină glicată (HbA1c)",unit:"%",min:0,max:5.7,cat:"Hormoni"},
  {name:"Cortizol",unit:"nmol/L",min:138,max:635,cat:"Hormoni"},
  {name:"Insulină",unit:"mUI/L",min:2.6,max:24.9,cat:"Hormoni"},
  {name:"Vitamina D",unit:"ng/mL",min:30,max:100,cat:"Hormoni"},
  {name:"Parathormon (PTH)",unit:"pg/mL",min:15,max:65,cat:"Hormoni"},
  // Minerale
  {name:"Fier seric",unit:"μmol/L",min:9,max:30,cat:"Minerale"},
  {name:"Calciu",unit:"mmol/L",min:2.1,max:2.6,cat:"Minerale"},
  {name:"Magneziu",unit:"mmol/L",min:0.7,max:1.0,cat:"Minerale"},
  {name:"Potasiu",unit:"mmol/L",min:3.5,max:5.1,cat:"Minerale"},
  {name:"Sodiu",unit:"mmol/L",min:136,max:145,cat:"Minerale"},
  {name:"Fosfor",unit:"mmol/L",min:0.8,max:1.5,cat:"Minerale"},
  {name:"Zinc",unit:"μmol/L",min:9,max:18,cat:"Minerale"},
  // Coagulare
  {name:"Indice internațional normalizat (INR)",unit:"",min:0.8,max:1.2,cat:"Coagulare"},
  {name:"D-dimeri",unit:"ng/mL",min:0,max:500,cat:"Coagulare"},
  {name:"Timp de tromboplastină parțial activată (APTT)",unit:"s",min:25,max:35,cat:"Coagulare"},
  {name:"Timp de protrombină (TP)",unit:"s",min:11,max:13.5,cat:"Coagulare"},
  {name:"Timp de sângerare",unit:"min",min:2,max:7,cat:"Coagulare"},
  // Hematologie extins
  {name:"Bazofile",unit:"%",min:0,max:1,cat:"Hematologie"},
  {name:"Indice de distribuție a eritrocitelor (RDW)",unit:"%",min:11.5,max:14.5,cat:"Hematologie"},
  {name:"Volum plachetar mediu (MPV)",unit:"fL",min:7.5,max:11.5,cat:"Hematologie"},
  {name:"Neutrofile absolute",unit:"10³/μL",min:2,max:7.5,cat:"Hematologie"},
  {name:"Limfocite absolute",unit:"10³/μL",min:1,max:4,cat:"Hematologie"},
  {name:"Monocite absolute",unit:"10³/μL",min:0.2,max:1,cat:"Hematologie"},
  {name:"Eozinofile absolute",unit:"10³/μL",min:0,max:0.5,cat:"Hematologie"},
  {name:"Bazofile absolute",unit:"10³/μL",min:0,max:0.2,cat:"Hematologie"},
  {name:"Reticulocite absolute",unit:"10³/μL",min:25,max:100,cat:"Hematologie"},
  // Biochimie extins
  {name:"Bilirubină directă",unit:"μmol/L",min:0,max:5.1,cat:"Biochimie"},
  {name:"Bilirubină indirectă",unit:"μmol/L",min:0,max:16,cat:"Biochimie"},
  {name:"Transferină",unit:"g/L",min:2,max:3.6,cat:"Biochimie"},
  {name:"Saturație transferină",unit:"%",min:20,max:50,cat:"Biochimie"},
  {name:"Capacitate totală de legare a fierului (CTLF)",unit:"μmol/L",min:45,max:76,cat:"Biochimie"},
  {name:"Haptoglobină",unit:"g/L",min:0.3,max:2,cat:"Biochimie"},
  {name:"Ceruloplasmină",unit:"g/L",min:0.2,max:0.6,cat:"Biochimie"},
  {name:"Homocisteină",unit:"μmol/L",min:5,max:15,cat:"Biochimie"},
  {name:"Lactat",unit:"mmol/L",min:0.5,max:2.2,cat:"Biochimie"},
  {name:"Amoniac",unit:"μmol/L",min:11,max:32,cat:"Biochimie"},
  {name:"Osmolalitate serică",unit:"mOsm/kg",min:275,max:295,cat:"Biochimie"},
  // Enzime extins
  {name:"Colinesterază",unit:"U/L",min:5320,max:12920,cat:"Enzime"},
  {name:"Aldolază",unit:"U/L",min:0,max:7.6,cat:"Enzime"},
  {name:"Creatin-kinaza, izoenzima MB (CK-MB)",unit:"U/L",min:0,max:25,cat:"Enzime"},
  {name:"Troponină I înalt sensibilă",unit:"ng/L",min:0,max:26,cat:"Enzime"},
  {name:"Peptid natriuretic tip B, fragment N-terminal (NT-proBNP)",unit:"pg/mL",min:0,max:125,cat:"Enzime"},
  {name:"Mioglobină",unit:"ng/mL",min:25,max:72,cat:"Enzime"},
  // Lipide extins
  {name:"Colesterol non-HDL",unit:"mmol/L",min:0,max:3.8,cat:"Lipide"},
  {name:"Apolipoproteina A1",unit:"g/L",min:1.05,max:2.05,cat:"Lipide"},
  {name:"Apolipoproteina B",unit:"g/L",min:0.6,max:1.4,cat:"Lipide"},
  {name:"Lipoproteina (a)",unit:"mg/dL",min:0,max:30,cat:"Lipide"},
  // Hormoni extins
  {name:"Triiodotironină totală (T3 total)",unit:"nmol/L",min:1.3,max:3.1,cat:"Hormoni"},
  {name:"Tiroxină totală (T4 total)",unit:"nmol/L",min:66,max:181,cat:"Hormoni"},
  {name:"Anticorpi anti-peroxidază tiroidiană (Anti-TPO)",unit:"UI/mL",min:0,max:34,cat:"Hormoni"},
  {name:"Anti-tiroglobulină",unit:"UI/mL",min:0,max:115,cat:"Hormoni"},
  {name:"Tiroglobulină",unit:"ng/mL",min:1.4,max:78,cat:"Hormoni"},
  {name:"Estradiol",unit:"pmol/L",cat:"Hormoni"},
  {name:"Progesteron",unit:"nmol/L",cat:"Hormoni"},
  {name:"Testosteron",unit:"nmol/L",cat:"Hormoni"},
  {name:"Prolactină",unit:"mUI/L",min:102,max:496,cat:"Hormoni"},
  {name:"Hormon luteinizant (LH)",unit:"UI/L",cat:"Hormoni"},
  {name:"Hormon foliculostimulant (FSH)",unit:"UI/L",cat:"Hormoni"},
  {name:"Dehidroepiandrosteron sulfat (DHEA-S)",unit:"μmol/L",cat:"Hormoni"},
  {name:"Hormon anti-Müllerian (AMH)",unit:"ng/mL",cat:"Hormoni"},
  {name:"Gonadotropină corionică umană beta (Beta-HCG)",unit:"UI/L",min:0,max:5,cat:"Hormoni"},
  {name:"Hormon adrenocorticotrop (ACTH)",unit:"pg/mL",min:7.2,max:63.3,cat:"Hormoni"},
  {name:"Hormon de creștere (GH)",unit:"ng/mL",min:0,max:10,cat:"Hormoni"},
  {name:"Factor de creștere insulin-like 1 (IGF-1)",unit:"ng/mL",cat:"Hormoni"},
  {name:"Aldosteron",unit:"pmol/L",cat:"Hormoni"},
  {name:"Renină",unit:"mUI/L",cat:"Hormoni"},
  {name:"Peptid C",unit:"nmol/L",min:0.37,max:1.47,cat:"Hormoni"},
  // Vitamine
  {name:"Vitamina B12",unit:"pmol/L",min:148,max:664,cat:"Vitamine"},
  {name:"Acid folic (Vitamina B9)",unit:"nmol/L",min:10.4,max:42.4,cat:"Vitamine"},
  {name:"Vitamina B1 (Tiamină)",unit:"nmol/L",min:70,max:180,cat:"Vitamine"},
  {name:"Vitamina B6",unit:"nmol/L",min:20,max:125,cat:"Vitamine"},
  {name:"Vitamina A",unit:"μmol/L",min:1.05,max:2.8,cat:"Vitamine"},
  {name:"Vitamina E",unit:"μmol/L",min:12,max:42,cat:"Vitamine"},
  {name:"Vitamina K",unit:"nmol/L",min:0.29,max:2.64,cat:"Vitamine"},
  {name:"Vitamina C",unit:"μmol/L",min:23,max:85,cat:"Vitamine"},
  // Minerale extins
  {name:"Cupru",unit:"μmol/L",min:11,max:22,cat:"Minerale"},
  {name:"Seleniu",unit:"μmol/L",min:0.75,max:1.85,cat:"Minerale"},
  {name:"Clor",unit:"mmol/L",min:98,max:107,cat:"Minerale"},
  {name:"Bicarbonat",unit:"mmol/L",min:22,max:29,cat:"Minerale"},
  {name:"Litiu",unit:"mmol/L",min:0.6,max:1.2,cat:"Minerale"},
  // Urină
  {name:"Creatinină urinară",unit:"mmol/24h",cat:"Urină"},
  {name:"Proteinurie",unit:"g/24h",min:0,max:0.15,cat:"Urină"},
  {name:"Microalbuminurie",unit:"mg/24h",min:0,max:30,cat:"Urină"},
  {name:"Glucozurie",unit:"mmol/L",min:0,max:0.8,cat:"Urină"},
  {name:"pH urinar",unit:"",min:4.5,max:8,cat:"Urină"},
  {name:"Densitate urinară",unit:"",min:1.005,max:1.03,cat:"Urină"},
  {name:"Raport albumină/creatinină (RAC)",unit:"mg/mmol",min:0,max:3,cat:"Urină"},
  // Imunologie
  {name:"Imunoglobulină A (IgA)",unit:"g/L",min:0.7,max:4,cat:"Imunologie"},
  {name:"Imunoglobulină G (IgG)",unit:"g/L",min:7,max:16,cat:"Imunologie"},
  {name:"Imunoglobulină M (IgM)",unit:"g/L",min:0.4,max:2.3,cat:"Imunologie"},
  {name:"Imunoglobulină E totală (IgE total)",unit:"UI/mL",min:0,max:100,cat:"Imunologie"},
  {name:"Anticorpi antinucleari (ANA)",unit:"titru",cat:"Imunologie"},
  {name:"Factor reumatoid",unit:"UI/mL",min:0,max:14,cat:"Imunologie"},
  {name:"Anticorpi anti-peptide citrulinate ciclice (Anti-CCP)",unit:"U/mL",min:0,max:5,cat:"Imunologie"},
  {name:"Complement C3",unit:"g/L",min:0.9,max:1.8,cat:"Imunologie"},
  {name:"Complement C4",unit:"g/L",min:0.1,max:0.4,cat:"Imunologie"},
  {name:"Antistreptolizina O (ASLO)",unit:"UI/mL",min:0,max:200,cat:"Imunologie"},
  // Markeri tumorali
  {name:"Antigen specific prostatic total (PSA total)",unit:"ng/mL",min:0,max:4,cat:"Markeri tumorali"},
  {name:"Antigen specific prostatic liber (PSA liber)",unit:"ng/mL",cat:"Markeri tumorali"},
  {name:"Antigen carcinoembrionar (CEA)",unit:"ng/mL",min:0,max:5,cat:"Markeri tumorali"},
  {name:"Antigen carbohidrat 125 (CA 125)",unit:"U/mL",min:0,max:35,cat:"Markeri tumorali"},
  {name:"Antigen carbohidrat 19-9 (CA 19-9)",unit:"U/mL",min:0,max:37,cat:"Markeri tumorali"},
  {name:"Antigen carbohidrat 15-3 (CA 15-3)",unit:"U/mL",min:0,max:30,cat:"Markeri tumorali"},
  {name:"Alfa-fetoproteină (AFP)",unit:"ng/mL",min:0,max:10,cat:"Markeri tumorali"},
  {name:"Proteina epididimală umană 4 (HE4)",unit:"pmol/L",cat:"Markeri tumorali"},
  {name:"Beta-2 microglobulină",unit:"mg/L",min:0.8,max:2.2,cat:"Markeri tumorali"},
  // Serologie / Infecții
  {name:"Anti-HBs",unit:"UI/L",cat:"Serologie"},
  {name:"AgHBs",unit:"",cat:"Serologie"},
  {name:"Anti-HCV",unit:"",cat:"Serologie"},
  {name:"Anti-HIV",unit:"",cat:"Serologie"},
  {name:"VDRL/RPR",unit:"",cat:"Serologie"},
  {name:"Anti-Helicobacter pylori IgG",unit:"U/mL",cat:"Serologie"},
  {name:"Anti-toxoplasma IgG",unit:"UI/mL",cat:"Serologie"},
  {name:"Anti-rubeolă IgG",unit:"UI/mL",cat:"Serologie"},
  {name:"Anti-CMV IgG",unit:"U/mL",cat:"Serologie"},
  {name:"Anti-EBV IgG",unit:"U/mL",cat:"Serologie"},
  // Gaze sanguine
  {name:"pH sanguin",unit:"",min:7.35,max:7.45,cat:"Gaze sanguine"},
  {name:"pO2",unit:"mmHg",min:75,max:100,cat:"Gaze sanguine"},
  {name:"pCO2",unit:"mmHg",min:35,max:45,cat:"Gaze sanguine"},
  {name:"Exces de baze",unit:"mmol/L",min:-2,max:2,cat:"Gaze sanguine"},
  {name:"Saturație O2 arterială (SaO2)",unit:"%",min:95,max:100,cat:"Gaze sanguine"},
  {name:"HCO3 actual",unit:"mmol/L",min:22,max:26,cat:"Gaze sanguine"},
  // Biochimie suplimentar
  {name:"Glicemie à jeun",unit:"mmol/L",min:3.9,max:5.6,cat:"Biochimie"},
  {name:"Glicemie postprandială",unit:"mmol/L",min:3.9,max:7.8,cat:"Biochimie"},
  {name:"Test de toleranță la glucoză (TTGO)",unit:"mmol/L",cat:"Biochimie"},
  {name:"Fructozamină",unit:"μmol/L",min:205,max:285,cat:"Biochimie"},
  {name:"Cistatin C",unit:"mg/L",min:0.53,max:0.95,cat:"Biochimie"},
  {name:"Rata de filtrare glomerulară estimată (eGFR)",unit:"mL/min/1.73m²",min:90,max:200,cat:"Biochimie"},
  {name:"Bilirubina neonatală",unit:"μmol/L",cat:"Biochimie"},
  {name:"Acizi biliari",unit:"μmol/L",min:0,max:10,cat:"Biochimie"},
  {name:"Alfa-1 antitripsină",unit:"g/L",min:0.9,max:2,cat:"Biochimie"},
  {name:"Electroforeza proteinelor serice",unit:"",cat:"Biochimie"},
  {name:"Alfa-amilaza pancreatică",unit:"U/L",min:13,max:53,cat:"Biochimie"},
  {name:"Adenozin-deaminaza (ADA)",unit:"U/L",cat:"Biochimie"},
  {name:"Acid lactic",unit:"mmol/L",min:0.5,max:2.2,cat:"Biochimie"},
  {name:"Piruvat",unit:"μmol/L",min:40,max:130,cat:"Biochimie"},
  // Hematologie suplimentar
  {name:"Hemoglobina fetală (HbF)",unit:"%",min:0,max:2,cat:"Hematologie"},
  {name:"Hemoglobina A2",unit:"%",min:1.5,max:3.5,cat:"Hematologie"},
  {name:"Electroforeza hemoglobinei",unit:"",cat:"Hematologie"},
  {name:"Test Coombs direct",unit:"",cat:"Hematologie"},
  {name:"Test Coombs indirect",unit:"",cat:"Hematologie"},
  {name:"Frotiu sânge periferic",unit:"",cat:"Hematologie"},
  {name:"Eritropoietina",unit:"mUI/mL",min:4.3,max:29,cat:"Hematologie"},
  {name:"Glucozo-6-fosfat dehidrogenază (G6PD)",unit:"U/g Hb",min:7,max:20.5,cat:"Hematologie"},
  {name:"Grup sanguin + Rh",unit:"",cat:"Hematologie"},
  // Coagulare suplimentar
  {name:"Factor VIII",unit:"%",min:50,max:150,cat:"Coagulare"},
  {name:"Factor IX",unit:"%",min:50,max:150,cat:"Coagulare"},
  {name:"Factor von Willebrand",unit:"%",min:50,max:160,cat:"Coagulare"},
  {name:"Proteina C",unit:"%",min:70,max:140,cat:"Coagulare"},
  {name:"Proteina S",unit:"%",min:60,max:140,cat:"Coagulare"},
  {name:"Antitrombina III",unit:"%",min:80,max:120,cat:"Coagulare"},
  {name:"Anticoagulant lupic",unit:"",cat:"Coagulare"},
  {name:"Anticorpi anticardiolipinici",unit:"GPL/MPL",cat:"Coagulare"},
  {name:"Mutația factor V Leiden",unit:"",cat:"Coagulare"},
  {name:"Mutația protrombina G20210A",unit:"",cat:"Coagulare"},
  // Hormoni suplimentar
  {name:"17-OH progesteron",unit:"nmol/L",cat:"Hormoni"},
  {name:"Androstendion",unit:"nmol/L",cat:"Hormoni"},
  {name:"Globulină de legare a hormonilor sexuali (SHBG)",unit:"nmol/L",min:18,max:144,cat:"Hormoni"},
  {name:"Testosteron liber",unit:"pmol/L",cat:"Hormoni"},
  {name:"Metanefrine plasmatice",unit:"pmol/L",cat:"Hormoni"},
  {name:"Catecolamine urinare",unit:"μg/24h",cat:"Hormoni"},
  {name:"Acid vanilmandelic (AVM)",unit:"mg/24h",min:0,max:13.6,cat:"Hormoni"},
  {name:"Serotonina",unit:"ng/mL",min:80,max:450,cat:"Hormoni"},
  {name:"Acid 5-hidroxiindolacetic (5-HIAA)",unit:"mg/24h",min:2,max:9,cat:"Hormoni"},
  {name:"Gastrina",unit:"pg/mL",min:13,max:115,cat:"Hormoni"},
  {name:"Calcitonina",unit:"pg/mL",min:0,max:10,cat:"Hormoni"},
  {name:"Leptina",unit:"ng/mL",cat:"Hormoni"},
  {name:"Melatonina",unit:"pg/mL",cat:"Hormoni"},
  // Vitamine suplimentar
  {name:"Vitamina D 1,25-OH (calcitriol)",unit:"pmol/L",min:60,max:160,cat:"Vitamine"},
  {name:"Biotina (Vitamina B7)",unit:"nmol/L",cat:"Vitamine"},
  {name:"Acid pantotenic (Vitamina B5)",unit:"μg/L",cat:"Vitamine"},
  {name:"Coenzima Q10",unit:"mg/L",min:0.5,max:1.5,cat:"Vitamine"},
  // Markeri tumorali suplimentar
  {name:"Antigen carbohidrat 72-4 (CA 72-4)",unit:"U/mL",min:0,max:6.9,cat:"Markeri tumorali"},
  {name:"Fragment de citokeratină 19 (CYFRA 21-1)",unit:"ng/mL",min:0,max:3.3,cat:"Markeri tumorali"},
  {name:"Enolaza neuron-specifică (NSE)",unit:"ng/mL",min:0,max:16.3,cat:"Markeri tumorali"},
  {name:"Antigen carcinom scuamos (SCC)",unit:"ng/mL",min:0,max:1.5,cat:"Markeri tumorali"},
  {name:"Cromogranina A",unit:"ng/mL",min:0,max:100,cat:"Markeri tumorali"},
  {name:"S100",unit:"μg/L",min:0,max:0.1,cat:"Markeri tumorali"},
  {name:"Calprotectina fecală",unit:"μg/g",min:0,max:50,cat:"Markeri tumorali"},
  {name:"Test hemoragii oculte fecale (FOB)",unit:"",cat:"Markeri tumorali"},
  // Imunologie suplimentar
  {name:"Anti-dsDNA",unit:"UI/mL",min:0,max:10,cat:"Imunologie"},
  {name:"Anti-Sm",unit:"U/mL",cat:"Imunologie"},
  {name:"Anti-SSA (Ro)",unit:"U/mL",cat:"Imunologie"},
  {name:"Anti-SSB (La)",unit:"U/mL",cat:"Imunologie"},
  {name:"Anti-Scl-70",unit:"U/mL",cat:"Imunologie"},
  {name:"Anti-Jo-1",unit:"U/mL",cat:"Imunologie"},
  {name:"Anti-centromer",unit:"U/mL",cat:"Imunologie"},
  {name:"Anti-RNP",unit:"U/mL",cat:"Imunologie"},
  {name:"c-ANCA (anti-PR3)",unit:"U/mL",cat:"Imunologie"},
  {name:"p-ANCA (anti-MPO)",unit:"U/mL",cat:"Imunologie"},
  {name:"Anti-transglutaminază IgA",unit:"U/mL",min:0,max:10,cat:"Imunologie"},
  {name:"Anti-gliadină",unit:"U/mL",cat:"Imunologie"},
  {name:"Anti-endomisium",unit:"titru",cat:"Imunologie"},
  {name:"Anti-mitocondriali (AMA)",unit:"titru",cat:"Imunologie"},
  {name:"Anti-mușchi neted (ASMA)",unit:"titru",cat:"Imunologie"},
  {name:"Anti-LKM1",unit:"U/mL",cat:"Imunologie"},
  {name:"Anti-receptor TSH (TRAb)",unit:"UI/L",min:0,max:1.75,cat:"Imunologie"},
  {name:"Anti-GAD",unit:"U/mL",cat:"Imunologie"},
  {name:"Anti-insulină",unit:"U/mL",cat:"Imunologie"},
  {name:"Triptaza",unit:"μg/L",min:0,max:11.4,cat:"Imunologie"},
  {name:"Interleukina-6 (IL-6)",unit:"pg/mL",min:0,max:7,cat:"Imunologie"},
  // Serologie suplimentar
  {name:"AgHBe",unit:"",cat:"Serologie"},
  {name:"Anti-HBe",unit:"",cat:"Serologie"},
  {name:"Anti-HBc IgM",unit:"",cat:"Serologie"},
  {name:"Anti-HBc total",unit:"",cat:"Serologie"},
  {name:"ARN HCV (viremie)",unit:"UI/mL",cat:"Serologie"},
  {name:"ADN HBV (viremie)",unit:"UI/mL",cat:"Serologie"},
  {name:"Anti-HAV IgM",unit:"",cat:"Serologie"},
  {name:"Anti-HAV IgG",unit:"",cat:"Serologie"},
  {name:"Anti-HEV IgM",unit:"",cat:"Serologie"},
  {name:"Anti-toxoplasma IgM",unit:"UI/mL",cat:"Serologie"},
  {name:"Anti-rubeolă IgM",unit:"UI/mL",cat:"Serologie"},
  {name:"Anti-CMV IgM",unit:"U/mL",cat:"Serologie"},
  {name:"Anti-EBV IgM (VCA)",unit:"U/mL",cat:"Serologie"},
  {name:"Anti-EBNA IgG",unit:"U/mL",cat:"Serologie"},
  {name:"Anti-Borrelia (Lyme) IgG/IgM",unit:"",cat:"Serologie"},
  {name:"Anti-Chlamydia trachomatis",unit:"",cat:"Serologie"},
  {name:"Anti-Mycoplasma pneumoniae",unit:"",cat:"Serologie"},
  {name:"TPHA",unit:"titru",cat:"Serologie"},
  {name:"Quantiferon TB Gold",unit:"UI/mL",cat:"Serologie"},
  {name:"Anti-SARS-CoV-2 IgG",unit:"AU/mL",cat:"Serologie"},
  {name:"Anti-varicelă IgG",unit:"",cat:"Serologie"},
  {name:"Anti-rujeolă IgG",unit:"",cat:"Serologie"},
  {name:"Anti-parotidită IgG",unit:"",cat:"Serologie"},
  // Urină suplimentar
  {name:"Sumar de urină",unit:"",cat:"Urină"},
  {name:"Urocultură",unit:"UFC/mL",cat:"Urină"},
  {name:"Sediment urinar",unit:"",cat:"Urină"},
  {name:"Cilindri urinari",unit:"",cat:"Urină"},
  {name:"Cristale urinare",unit:"",cat:"Urină"},
  {name:"Urobilinogen",unit:"μmol/L",min:0,max:17,cat:"Urină"},
  {name:"Bilirubinurie",unit:"",cat:"Urină"},
  {name:"Cetonurie",unit:"",cat:"Urină"},
  {name:"Nitriți urinari",unit:"",cat:"Urină"},
  {name:"Leucocit-esteraza",unit:"",cat:"Urină"},
  {name:"Acid uric urinar",unit:"mmol/24h",min:1.5,max:4.5,cat:"Urină"},
  {name:"Calciu urinar",unit:"mmol/24h",min:2.5,max:7.5,cat:"Urină"},
  {name:"Fosfor urinar",unit:"mmol/24h",cat:"Urină"},
  {name:"Potasiu urinar",unit:"mmol/24h",min:25,max:125,cat:"Urină"},
  {name:"Sodiu urinar",unit:"mmol/24h",min:40,max:220,cat:"Urină"},
  {name:"Cortizol liber urinar",unit:"nmol/24h",min:100,max:379,cat:"Urină"},
  // Materii fecale
  {name:"Coprocultură",unit:"",cat:"Materii fecale"},
  {name:"Examen coproparazitologic",unit:"",cat:"Materii fecale"},
  {name:"Antigen Helicobacter pylori fecal",unit:"",cat:"Materii fecale"},
  {name:"Antigen Giardia fecal",unit:"",cat:"Materii fecale"},
  {name:"Antigen rotavirus/adenovirus",unit:"",cat:"Materii fecale"},
  {name:"Toxina Clostridium difficile A/B",unit:"",cat:"Materii fecale"},
  {name:"Elastaza pancreatică fecală",unit:"μg/g",min:200,max:1000,cat:"Materii fecale"},
  {name:"Grăsimi fecale",unit:"g/24h",min:0,max:7,cat:"Materii fecale"},
  // Medicamente / Toxicologie
  {name:"Digoxinemie",unit:"nmol/L",min:0.6,max:1.2,cat:"Medicamente"},
  {name:"Litemie",unit:"mmol/L",min:0.6,max:1.2,cat:"Medicamente"},
  {name:"Valproat seric",unit:"μmol/L",min:350,max:700,cat:"Medicamente"},
  {name:"Carbamazepină serică",unit:"μmol/L",min:17,max:51,cat:"Medicamente"},
  {name:"Fenitoină serică",unit:"μmol/L",min:40,max:79,cat:"Medicamente"},
  {name:"Teofilină serică",unit:"μmol/L",min:55,max:110,cat:"Medicamente"},
  {name:"Vancomicină (nivel bazal)",unit:"mg/L",min:10,max:20,cat:"Medicamente"},
  {name:"Tacrolimus",unit:"μg/L",min:5,max:15,cat:"Medicamente"},
  {name:"Ciclosporină",unit:"μg/L",min:100,max:300,cat:"Medicamente"},
  {name:"Metotrexat seric",unit:"μmol/L",cat:"Medicamente"},
  {name:"Alcoolemie",unit:"g/L",min:0,max:0,cat:"Medicamente"},
  // Alergologie
  {name:"IgE specific acarieni",unit:"kU/L",min:0,max:0.35,cat:"Alergologie"},
  {name:"IgE specific polen",unit:"kU/L",min:0,max:0.35,cat:"Alergologie"},
  {name:"IgE specific alimente",unit:"kU/L",min:0,max:0.35,cat:"Alergologie"},
  {name:"IgE specific păr animale",unit:"kU/L",min:0,max:0.35,cat:"Alergologie"},
  {name:"Panel alergeni respiratori",unit:"",cat:"Alergologie"},
  {name:"Panel alergeni alimentari",unit:"",cat:"Alergologie"},
  {name:"ECP (proteina cationică eozinofilică)",unit:"μg/L",min:0,max:24,cat:"Alergologie"},
  // Completări — analize frecvente care lipseau
  {name:"Trombocitocrit (PCT)",unit:"%",min:0.17,max:0.35,cat:"Hematologie"},
  {name:"Raport neutrofile/limfocite (NLR)",unit:"",cat:"Hematologie"},
  {name:"Globuline serice",unit:"g/L",min:20,max:35,cat:"Biochimie"},
  {name:"Raport albumine/globuline (A/G)",unit:"",min:1.1,max:2.5,cat:"Biochimie"},
  {name:"Amilază urinară",unit:"U/L",cat:"Biochimie"},
  {name:"Osmolalitate urinară",unit:"mOsm/kg",min:300,max:900,cat:"Urină"},
  {name:"Index aterogen (Colesterol total/HDL)",unit:"",min:0,max:4.5,cat:"Lipide"},
  {name:"Raport LDL/HDL",unit:"",min:0,max:3.5,cat:"Lipide"},
  {name:"Activitate de protrombină (AP)",unit:"%",min:70,max:120,cat:"Coagulare"},
  {name:"Timp de trombină (TT)",unit:"s",min:14,max:21,cat:"Coagulare"},
  {name:"Beta-CrossLaps (CTX)",unit:"ng/mL",cat:"Hormoni"},
  {name:"Osteocalcină",unit:"ng/mL",min:11,max:43,cat:"Hormoni"},
  {name:"Propeptid N-terminal al procolagenului tip 1 (P1NP)",unit:"ng/mL",cat:"Hormoni"},
  {name:"Enzima de conversie a angiotensinei (ECA)",unit:"U/L",min:8,max:52,cat:"Enzime"},
  {name:"Imunoglobulină G4 (IgG4)",unit:"g/L",min:0.03,max:2.01,cat:"Imunologie"},
  {name:"Acid metilmalonic",unit:"nmol/L",min:73,max:271,cat:"Biochimie"},
];

export const VACCINE_LIST = {
  "Calendar Național (copilărie)": [
    "Hepatită B (la naștere)","BCG / tuberculoză (la naștere, 4-7 zile)",
    "Hexavalent DTPa-VPI-Hib-HepB (2, 4, 11 luni)","Pneumococic PCV (2, 4, 11 luni)",
    "ROR rujeolă-rubeolă-oreion (1 an, 5 ani)","DTPa rapel (6 ani)",
    "dT rapel (14 ani, apoi la 10 ani)","VPI poliomielită (6 ani)",
    "HPV papilomavirus (11-14 ani, fete și băieți)"
  ],
  "Recomandate / opționale": [
    "HPV (papilomavirus)","Gripal (antigripal)","Varicelă","Rotavirus",
    "Meningococic","Hepatită A","Herpes Zoster","COVID-19","Encefalită de căpușă (TBE)"
  ],
  "Călătorie": [
    "Febră galbenă","Febră tifoidă","Holeră","Rabie","Encefalită japoneză"
  ]
};

export const CYCLE_SYMPTOMS = [
  // Durere
  "Crampe","Crampe severe","Dureri de spate","Dureri pelviene","Dureri de picioare","Dureri de cap","Migrenă","Dureri articulare","Dureri ovariene",
  // Sâni
  "Dureri de sâni","Sâni sensibili","Sâni umflați",
  // Digestiv / abdomen
  "Balonare","Retenție de apă","Greață","Vărsături","Constipație","Diaree","Crampe abdominale","Gaze",
  // Energie / somn
  "Oboseală","Epuizare","Insomnie","Somnolență","Amețeli","Leșin",
  // Dispoziție
  "Iritabilitate","Anxietate","Tristețe","Schimbări de dispoziție","Plâns ușor","Nervozitate","Lipsă de concentrare","Sensibilitate emoțională",
  // Pofte / apetit
  "Poftă de dulce","Poftă de sărat","Poftă de mâncare","Lipsa poftei de mâncare",
  // Piele
  "Acnee","Piele grasă","Erupții cutanate",
  // Scurgeri menstruale (flux)
  "Flux abundent","Flux moderat","Flux redus","Spotting (pătare)","Cheaguri",
  // Scurgeri vaginale (mucus)
  "Scurgeri albe","Scurgeri transparente","Scurgeri lăptoase","Scurgeri ca albușul de ou","Scurgeri lipicioase","Scurgeri maronii","Scurgeri roz","Scurgeri abundente","Scurgeri reduse","Uscăciune vaginală",
  // Libido / altele
  "Libido crescut","Libido scăzut","Bufeuri","Transpirații nocturne","Sensibilitate la mirosuri","Mâncărimi","Mâncărime vaginală","Sângerare intermenstruală"
];

// Zilele săptămânii (Luni prima), pentru calendare
export const WDAYS = ["Lu","Ma","Mi","Jo","Vi","Sâ","Du"];

// Paletă de culori stabile pentru badge-urile îngrijitorilor
export const CAREGIVER_PALETTE = ["var(--purple)","#f472b6","var(--green)","var(--amber)","var(--blue)","var(--amber-2)","#22d3ee","#a3e635"];

// Grupele sanguine (fără numerotarea I/II/III/IV, semnele Rh incluse)
export const BLOOD_TYPES = ["0 Rh+","0 Rh−","A Rh+","A Rh−","B Rh+","B Rh−","AB Rh+","AB Rh−"];

// Județele României (42, inclusiv Municipiul București) — pentru dropdown-ul de adresă
export const JUDETE = [
  "Alba","Arad","Argeș","Bacău","Bihor","Bistrița-Năsăud","Botoșani","Brașov","Brăila","București",
  "Buzău","Caraș-Severin","Călărași","Cluj","Constanța","Covasna","Dâmbovița","Dolj","Galați","Giurgiu",
  "Gorj","Harghita","Hunedoara","Ialomița","Iași","Ilfov","Maramureș","Mehedinți","Mureș","Neamț",
  "Olt","Prahova","Satu Mare","Sălaj","Sibiu","Suceava","Teleorman","Timiș","Tulcea","Vaslui","Vâlcea","Vrancea"
];

// Localitățile României (județ → listă localități), încărcate lazy dintr-un fișier
// din /public (~180KB) — ca să nu îngreuneze bundle-ul principal.
let _locCache = null, _locPromise = null;
export function loadLocalities() {
  if(_locCache) return Promise.resolve(_locCache);
  if(!_locPromise) {
    _locPromise = fetch('/localitati.json')
      .then(r => r.ok ? r.json() : {})
      .then(d => { _locCache = d || {}; return _locCache; })
      .catch(() => { _locPromise = null; return {}; });
  }
  return _locPromise;
}
